export const MODALS = {
    contactUs: "contact-us",
    projectSoon: "project-soon",
    review: "review",
};
